<template>
    <div class="pt-3 p-md-3">
        <!-- cover card -->
        <div class="row">
            <div class="col">
                <div class="card rounded-lg position-relative">
                    <div class="card-img-top profile-cover cover">
                        <button @click="coverChange"
                                class="btn btn-sm btn-light shadow-none rounded-pill position-absolute cover-change-button">
                            Cover change
                        </button>
                      <img :src="user?.cover_picture?.full_url || urlGenerator('/images/default-cover.png')" class="" alt="cover image"/>
                    </div>
                    <!-- profile picture -->
                    <div class="avatar d-flex flex-column flex-md-row align-items-center gap-x-1"
                         style="pointer-events: none;">
                        <div class="rounded-circle profile-uploader position-relative" style="pointer-events: auto;">
                            <!-- <img :src="getImg(profileUser)" alt="pp">-->
                            <img :src="user?.profile_picture?.full_url || urlGenerator('/images/avatar-demo.jpg')" alt="pp">
                            <span @click="profilePictureChange"
                                  class="w-100 h-100 justify-content-center align-items-center profile-uploader--text">change</span>
                        </div>
                        <div class="text-white text-center text-md-left">
                            <h4 class="p-0 m-0">{{ user.full_name }}</h4>
                        </div>
                    </div>
                    <div class="card-footer bg-transparent">
                        <div class="d-flex justify-content-center justify-content-md-end">
                            <a :href="urlGenerator('/profile/' + user.uuid)" class="btn btn-link py-0" :class="{ 'text-primary': location.pathname.split('/').includes('profile') }">
                                <app-icon class="mr-1" name="user"/>
                                Profile</a>
                            <!--                            <a href="#flowers" class="btn btn-link py-0">-->
                            <!--                                <app-icon class="mr-1" name="heart"/>-->
                            <!--                                Flowers</a>-->
                            <!--                            <a href="#friends" class="btn btn-link py-0">-->
                            <!--                                <app-icon class="mr-1" name="users"/>-->
                            <!--                                Friends</a>-->
                            <a :href="urlGenerator('/gallery/' + user.uuid)" class="btn btn-link py-0" :class="{ 'text-primary': location.pathname.split('/').includes('gallery') }">
                                <app-icon class="mr-1" name="image"/>
                                Gallery</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- content -->
        <div class="row mt-3">
            <div class="col">
                <app-pre-loader v-if="loading" />
                <template v-else>
                    <gallery :galleryID="`gallery-id-${profileUser.id}`" :images="gallery" grid/>
                </template>
                <app-empty-data-block v-if="!gallery.length" :message="$t('empty_data_block_gallery')"/>
            </div>
        </div>

    </div>
</template>

<script>
import AppButton from '../../../../../core/components/buttons/AppButton.vue';
import NewPost from "../feed/NewPost";
import PostView from "../feed/PostView";
import {mapGetters, mapActions} from 'vuex'
import {axiosPost, urlGenerator} from "../../../../helpers/AxiosHelper";
import {COVER_PICTURE_CHANGE, PROFILE_PICTURE_CHANGE} from "../../../../config/ApiUrl";
import Gallery from "../others/Gallery/Gallery";
export default {
    components: {AppButton, NewPost, PostView, Gallery},
    props: {
        profileUser: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            location,
            urlGenerator
        };
    },
    methods: {
        ...mapActions({
            getLoginUser: 'getUser'
        }),
        profilePictureChange() {
            let input = document.createElement('input')
            input.type = 'file'
            input.accept = '.jpg, .png, .gif, .webp, .jpeg'
            input.click();
            input.addEventListener('change', (event) => {
                let avatar = event.target.files[0]
                let formData = new FormData();
                formData.append('profile_picture', avatar)
                axiosPost(PROFILE_PICTURE_CHANGE, formData).then(res => {
                    console.log(res)
                }).finally(() => {
                    this.getLoginUser()
                })
            })
        },
        coverChange() {
            let input = document.createElement('input')
            input.type = 'file'
            input.accept = '.jpg, .png, .gif, .webp, .jpeg'
            input.click();
            input.addEventListener('change', (event) => {
                let cover = event.target.files[0]
                let formData = new FormData();
                formData.append('cover_picture', cover)
                axiosPost(COVER_PICTURE_CHANGE, formData).then(res => {
                    console.log(res)
                }).finally(() => {
                    this.getLoginUser()
                })
            })
        },
        getImg(user) {
            return user.profile_picture?.full_url ? user.profile_picture.full_url : urlGenerator('/images/avatar-demo.jpg');
        }
    },
    computed: {
        ...mapGetters({
            gallery: 'gallery/list',
            loading: 'gallery/loading',
            user: 'loggedInUser'
        })
    },
    created() {
        this.$store.dispatch('gallery/getAll', {id: window.user.id})
    }
};
</script>

<style scoped lang="scss">
.avatar {
    position: absolute;
    bottom: 52px;
    width: 100%;

    img {
        width: 72px;
        height: 72px;
    }
}

.rounded-lg {
    border-radius: 15px !important;
    overflow: hidden;
}

.profile-cover {
    object-fit: cover;
    img{
        min-height: 148px;
        max-height: 148px;
    }
}

.bold {
    font-weight: bold !important;
}

.profile-uploader {
    cursor: pointer;
    overflow: hidden;

    &--text {
        transition: .2s ease-in;
        display: flex;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #00000080;
        z-index: 900;
        color: #fff;
    }

    &:hover {
        .profile-uploader--text {
            opacity: 1;
        }
    }
}

.cover {
    overflow: hidden;
    position: relative;

    img {
        width: 100%;
        object-fit: cover;
    }

    &-change-button {
        opacity: 0;
        top: 10px;
        left: 10px;
    }

    &:hover .cover-change-button {
        opacity: 1;
    }
}

.cover-change-button {
}

@media screen and (min-width: 768px) {
    .profile-cover {
        max-height: 200px;
        height: auto;
    }

    .avatar {
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: auto;

        img {
            width: 112px;
            height: 112px;
        }
    }
}
</style>